import React from 'react'
import styled from 'styled-components'
import { useGlobal, useDispatch } from 'reactn'
import { withRouter } from 'react-router-dom'
import { FadeIn } from 'animate-css-styled-components'
import EditForm from 'components/Forms/thread/create'
import EditAndDeleteButtons from 'components/Forms/EditAndDeleteButtons'
import { FeatureCard, LineText } from 'components/common'
import ThreadHeaderInfo from './HeaderInfo'

const Summary = styled.p`
  margin: 0;
  color: var(--text-default);
  font-size: 1rem;
  line-height: 1.9;
`

const SingleThread = ({ auth, history }) => {
  const [thread, setThread] = useGlobal('threads/get')
  const threadPatch = useDispatch('threads/patch')

  const threadRemove = useDispatch('threads/remove')
  const [state, setState] = React.useState({
    showEditForm: false,
    title: '',
    summary: ''
  })

  const handleOnChange = ({ target }) => setState({ ...state, [target.id]: target.value })

  const handleEditThreadSubmit = async (event) => {
    event.preventDefault()
    const { title, summary } = state
    const payload = { title, summary }
    const globalState = await threadPatch(thread.id, payload)
    const updatedData = globalState['threads/patch']
    setThread(updatedData)
    setState({ ...state, showEditForm: false })
  }

  const removeThread = async () => {
    await threadRemove(thread.id)
    history.goBack()
  }

  return (
    <FeatureCard className='mb-4'>
      <div className='app-card-header'>
        <ThreadHeaderInfo thread={thread} />
      </div>
      <div className='app-card-body text-left'>
        <Summary>{thread.summary}</Summary>
        <LineText className='d-block mt-3'>UserID: {thread._user.id}</LineText>

        {auth.user && auth.user.id === thread.creator_id ? <EditAndDeleteButtons onEdit={() => setState({ ...state, showEditForm: true })} onDelete={removeThread} /> : null}

        {state.showEditForm ? <FadeIn><div className='mt-3'><EditForm onSubmit={handleEditThreadSubmit} onChange={handleOnChange} /></div></FadeIn> : null}
      </div>
    </FeatureCard>
  )
}

export default withRouter(SingleThread)
